import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTracker } from "@dpdgroupuk/react-event-tracker";

import { parseQuery, stringifyQuery } from "../utils/query";
import { clearRouteDetail } from "../store/actions/route";
import { ROUTES } from "../constants/analytics";

export const useRouteClicks = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const tracker = useTracker();

  const onClick = useCallback(
    (route) => {
      const { routeId, detailVisible, ...newQuery } = parseQuery(
        history.location.search
      );
      const isSameRoute = routeId === route.routeId;

      if (detailVisible) {
        return;
      }

      history.push({
        search: stringifyQuery({
          ...newQuery,
          detailVisible: undefined,
          routeId: isSameRoute ? undefined : route.routeId,
        }),
      });

      tracker.logEvent(ROUTES.CLICK_ROUTE);
    },
    [history, tracker]
  );

  const onDoubleClick = useCallback(
    (route) => {
      const query = parseQuery(history.location.search);

      history.push({
        search: stringifyQuery({
          ...query,
          routeId: route.routeId,
          detailVisible: query.detailVisible ? undefined : true,
        }),
      });
      dispatch(clearRouteDetail());

      tracker.logEvent(ROUTES.DOUBLE_CLICK_ROUTE);
    },
    [history, tracker, dispatch]
  );

  return [onClick, onDoubleClick];
};
